export default __webpack_public_path__ + "static/media/bomb.50cb791f.svg";